var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconTShirt = function SvgIconTShirt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.457 2.91 1.145 5.56l-.008.006a1.76 1.76 0 0 0-.695 2.15l.004.008 1.434 3.45.005.012a1.76 1.76 0 0 0 1.607 1.064H5v7.25a1.75 1.75 0 0 0 1.75 1.75h10.5A1.75 1.75 0 0 0 19 19.5v-7.25h1.508a1.76 1.76 0 0 0 1.608-1.064l.004-.012 1.435-3.45.003-.008a1.76 1.76 0 0 0-.695-2.15l-.008-.006-4.318-2.654a1 1 0 0 0-.553-.156H15a1 1 0 0 0-1 1 2 2 0 1 1-4 0 1 1 0 0 0-1-1H6.016a1 1 0 0 0-.559.16M19 5.538v4.712h1.339l1.287-3.097zm-2-.788h-1.127a4 4 0 0 1-7.746 0H7v14.5h10zm-12 5.5V5.539L2.374 7.153l1.288 3.097z",
    clipRule: "evenodd"
  })));
};
export default SvgIconTShirt;